import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Card, LinearProgress } from '@mui/material'
import { useSession } from 'components/Providers'
import { retrieve as seachFinalGrades } from 'store/academic/grade-finalGrade'
import FinalGrades from 'components/FinalGrades'
// import { search } from 'store/academic/grading-scales'
import NotFound from 'components/NotFound'
import PageHeader from 'components/AppBar/PageHeader'
import Header from 'components/Header'
import usePrintArea from 'utils/print'

export default function GradingReports() {
  const dispatch = useDispatch()
  const { person, academicYear, school } = useSession()
  const grades = useSelector(state => state.academic.grade_finalGrade?.list || [])
  const [notFound, setNotFound] = useState(false)
  const markingPeriods = academicYear?.markingPeriods
  const courseSessionEnrollmentGrades = grades?.data
  const gpas = grades?.gpas
  const basePath = '/academic/grading-report'
  const type = person?.type

  const session = useSelector(state => state.session)
  const personMemberId = session.id
  const parentStudentId = useSelector(state => state.session.studentMemberId);
  const parentStudent = useSelector(state => state.academic?.parentStudent?.selectedStudent);

  const studentName = type === 'parent'
    ? `${parentStudent?.firstName ?? ''} ${parentStudent?.lastName ?? ''}`.trim()
    : `${person?.firstName ?? ''} ${person?.lastName ?? ''}`.trim()

  const { printRef, print } = usePrintArea({
    title: `${studentName} - Grades - ${academicYear?.name ?? ''}`.trim(),
  })

  useEffect(() => {
    const personType = type === 'parent' ? 'student' : type;
    const memberId = type === 'parent' ? parentStudentId : personMemberId;

    if (!memberId || !personType) return

    dispatch(seachFinalGrades({ type: personType, memberId }))
      .then(res => {
        if (res.error) {
          setNotFound(true);
        }
      })
      .catch(err => {
        console.error('Error fetching grades:', err);
      });
  }, [dispatch, personMemberId, type, parentStudentId]);

  if (!personMemberId || (type === 'parent' && !parentStudentId)) return <LinearProgress color="primary" />

  return (
    <Box sx={{ minHeight: '50%' }}>
      <Box sx={{ pb: 2 }}>
        <PageHeader title={'Grades'} />
      </Box>
      <Card ref={printRef}>
        <Box sx={{ pl: 2, pr: 0.5 }}>
          <Header
            title={type === 'parent' ? `${studentName}'s Grades` : studentName}
            small
            print
            printTitle={`${studentName} - ${school?.name ?? ''} - ${academicYear?.name ?? ''}`}
            printfunc={print}
          />
        </Box>
        {notFound ? (
          <NotFound basePath={`${basePath}`} />
        ) : (
          <FinalGrades
            courseSessionEnrollmentGrades={courseSessionEnrollmentGrades}
            markingPeriods={markingPeriods}
            gpas={gpas}
          />
        )}
      </Card>
    </Box>
  )
}
